export const SF_ENTITY_LABELS = {
  Contact: 'Contact Smart Fields',
  GroupMember: 'Group Contact Smart Fields',
  PartyGuest: 'Event Guest Smart Fields',
};

export const SF_ENTITY_PLURAL_LABELS = {
  Contact: 'Contacts',
  GroupMember: 'Groups',
  PartyGuest: 'Events',
};

export const SF_ENTITY_DISPLAY_NAMES = {
  Contact: 'Contacts',
  GroupMember: 'Group Contacts',
  PartyGuest: 'Event Guests',
};
